// extracted by mini-css-extract-plugin
export default {"container":"EmptyGroup_container__n2peP"};